import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../SellerMyStore/SellerMyStore.css";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";
import placeholder from "../../assets/placeholder.jpg";

export default function SellerMyStore() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const token = localStorage.getItem("token");

  axios
    .get(`${BaseUrl}saller/products/list-product-ad`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
    .then((res) => {
      console.log(res.data);
      setItems(res?.data?.data || []);
    })
    .catch((err) => console.error(err))
    .finally(() => {
      setLoading(false);
    });

}, []);   // لازم القوس ده يبقى موجود
  return (
    <div className="sellerrelated-section m-auto pb-5 pt-4">
      <div className="related-header mb-5 pb-5"></div>

      <div className="related-cards mb-5">

        {/* ========= Skeleton (زي Confirm) ========= */}
        {loading &&
          [1].map((i) => (
            <div key={i} className="order-skeleton-card">
              <div className="skeleton-lock"></div>

              <div className="skeleton-middle">
                <div className="skeleton-line short"></div>
                <div className="skeleton-line medium"></div>
              </div>

              <div className="skeleton-right">
                <div className="skeleton-badge"></div>
                
                <div className="skeleton-line small"></div>
              </div>
            </div>
          ))}

        {/* ========= Empty ========= */}
        {!loading && items.length === 0 && (
          <h2 className="text-center mt-5">
            لا يوجد إعلانات حالياً
          </h2>
        )}

        {/* ========= Cards ========= */}
        {!loading &&
          items.map((item) => (
            <Link
              key={item.id}
              to={`/seller/selleradvertisementdetails/${item.id}`}
              className="related-card"
            >
              <img
                loading="lazy"
                // src={
                //   Array.isArray(item.image)
                //     ? item.image[0]
                //     : item.image || placeholder
                // }
                src={
  Array.isArray(item.image)
    ? item.image[0]?.url || placeholder
    : item.image || placeholder
}
                alt={item.name}
                onError={(e) => {
                  e.target.src = placeholder;
                }}
              />
              {/* <Link
  key={item.id}
  to={`/seller/selleradvertisementdetails/${item.id}`}
  className="related-card"
></Link> */}
<div className="discount-badgestore">
  {item.discount || 10}%
</div>

              <h4 className="fw-bold mystore-heading" >{item.name?.slice(0,31)}...</h4>

              <p className="desc">
                {item.description}
              </p>

{/* 
              <p className="price">
                {item.priceAfterDiscount
                  ? `${item.price} ر.س`
                  : 
                  `${item.price} ر.س`}
              </p> */}
              <p className="price">
  {item.priceAfterDiscount || item.price} ر.س
</p>
            </Link>
          ))}
      </div>
    </div>
  );
}
